<template>
  <div
    class="banner"
    :style="
      screenWidth > 1000
        ? 'background: url(https://static.newcornerstone.org.cn/resources/media/bsa-banner-poster.jpg) center / cover no-repeat;'
        : 'background: url(/resources/media/bsa-banner-poster-h5.jpg) center / cover no-repeat;'
    "
  >
    <div
      v-if="pageYOffset > 800"
      class="banner-mask"
    />
    <Swiper
      class="banner-swiper one"
      :modules="modules"
      :autoplay="autoplayOptions"
      :pagination="{
        clickable: true,
      }"
      @swiper="onSwiper"
    >
      <swiper-slide>
        <div class="demo_item">
          <div
            class="video_mask"
            @click="playVideo(index)"
          />
          <div class="content_tw">
            <div
              v-if="isCN"
              class="view_content"
            >
              <p>
                <span>新基石 <i>聚焦原始创新</i></span>
              </p>
              <p>
                <span>新基石 <i>鼓励自由探索</i></span>
              </p>
              <p>
                <span>新基石 <i>推动科学发展</i></span>
              </p>
            </div>
            <div
              v-else
              class="view_content"
            >
              <p>
                <span>Foster <i>Innovation</i></span>
              </p>
              <p>
                <span>Encourage <i>Exploration</i></span>
              </p>
              <p>
                <span>Promote <i>Basic Research</i></span>
              </p>
            </div>
          </div>
          <!-- 申报中 -->
          <div
            v-if="banner && banner.length > 0"
            class="tips-content"
          >
            <div class="line"></div>
            <div
              v-if="showTips"
              class="tips-text"
              @click="toLink(isCN ? banner[0].link_to : banner[0].link_toEn)"
            >
              {{ tips }}
            </div>
            <div class="line"></div>
          </div>
          <div
            v-if="showEndTime"
            class="end-time"
          >
            {{ endTime }}
          </div>
          <div
            :style="`opacity: ${buttonHide}`"
            :class="isCN ? 'declare-button' : 'declare-button en-button'"
            @click="
              toLink(
                isCN
                  ? 'https://www.newcornerstone.org.cn/#/registration?lang=zh-CN'
                  : 'https://www.newcornerstone.org.cn/#/registration?lang=en-US',
              )
            "
          >
            <div class="title">{{ isCN ? '立即申报' : 'Apply Now' }}</div>
            <div class="t_button_img">
              <div class="t_button_img_an">
                <img
                  src="/resources/img/icon_jiantou.png"
                  alt="application"
                />
              </div>
            </div>
          </div>
          <!-- 即将开始申报 -->
          <!-- <template v-else>
            <div class="decalre-begin">本年度新基石研究员项目申报即将开放</div>
            <div class="end-time">开始时间2025年4月15日上午10:00（北京时间）</div>
          </template> -->
          <video
            v-show="canPlay && screenWidth > 1000"
            :id="'bannerVideo_' + index"
            autoplay
            loop="loop"
            preload="preload"
            muted
            x-webkit-airplay="true"
            airplay="allow"
            webkit-playsinline
            playsinline
            x5-playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            height="100%"
            style="object-fit: cover !important"
            @canplay="setPlayVideo"
          >
            <source
              src="https://static.newcornerstone.org.cn/resources/media/bsa-banner.mp4"
              type="video/mp4"
            />
            您的浏览器不支持该视频格式。
          </video>
        </div>
      </swiper-slide>
    </Swiper>
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper';
import { ref, computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import 'swiper/css';
import 'swiper/css/pagination';

const props = defineProps({
  banner: {
    type: Array,
    default() {
      return [];
    },
  },
  link: {
    type: Array,
    default() {
      return [];
    },
  },
  pageYOffset: {
    type: Number,
    default: 0,
  },
  screenWidth: {
    type: Number,
    default: 0,
  },
  time: {
    type: Number,
    default: null,
  },
});
const modules = [Autoplay, Pagination];
const canPlay = ref(false);
const { locale } = useI18n();
const langType = ref(localStorage.getItem('lang') || 'zh-CN');
const isCN = computed(() => langType.value === 'zh-CN');

// 监控语言切换，重新赋值语言类型
watch(
  () => locale.value,
  (nv) => {
    // console.log('langType', langType.value, isCN.value);
    langType.value = nv;
  },
);
// 处理申报按钮渐隐
const buttonHide = computed(() => {
  // 超出高度隐藏
  if (props.pageYOffset > 180) {
    return 0;
  }
  if (props.pageYOffset > 170) {
    return 0.25;
  }
  if (props.pageYOffset > 160) {
    return 0.5;
  }
  if (props.pageYOffset > 150) {
    return 0.75;
  }
  if (props.pageYOffset > 140) {
    return 1;
  }
  return 1;
});

const showTips = computed(() => {
  if (props.banner?.length === 0) return '';
  return props.banner[0]?.commonTips && props.banner[0]?.commonTips_en;
});

const tips = computed(() => {
  if (props.banner?.length === 0) return '';
  return isCN.value ? props.banner[0]?.commonTips || '' : props.banner[0]?.commonTips_en || '';
});

const showEndTime = computed(() => {
  if (props.banner?.length === 0) return '';
  return props.banner[0]?.declareTime && props.banner[0]?.declareTime_en;
});

const endTime = computed(() => {
  if (props.banner?.length === 0) return '';
  return isCN.value ? props.banner[0]?.declareTime || '' : props.banner[0]?.declareTime_en || '';
});

// eslint-disable-next-line no-undef
const onSwiper = (swiper) => {
  console.log(swiper);
};
// const onSlideChange = (swiper) => {
//   const cur = swiper.activeIndex;
//   // curIndex = cur;
//   if (props?.banner[cur] && props?.banner[cur]?.type === 'video') {
//     playVideo(cur);
//   } else if (props?.banner[preIndex.value]?.type === 'video') {
//     stopVideo(preIndex.value);
//   }
//   preIndex.value = cur;
// };

// 自动轮播的配置
const autoplayOptions = {
  delay: 10000,
  loop: true,
  disableOnInteraction: false, // 设置为false，自动播放将不会在用户交互(滑动)后被禁用，每次交互后都会重新启动
};
const playVideo = (index) => {
  const myVideo = document.getElementById(`bannerVideo_${index}`);
  if (myVideo) myVideo.play();
};
// const stopVideo = (index) => {
//   const myVideo = document.getElementById(`bannerVideo_${index}`);
//   if (myVideo) {
//     myVideo.pause();
//   }
// };
const setPlayVideo = () => {
  setTimeout(() => {
    canPlay.value = true;
  }, 200);
};
const toLink = (url) => {
  window.open(url, '_blank');
};

onMounted(() => {
  document.body.classList.add('declare');
});
</script>
<style lang="scss" scoped>
.banner-mask {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 11;
}
.banner-swiper {
  color: #eee;
  width: 100%;
  min-height: 900px;
  :deep(.t-swiper__wrap) {
    color: #eee;
    .t-swiper__navigation-bars {
      color: #ccc;
      .t-swiper__navigation-item {
        width: 100px;
        padding: 38px 0;
        &:not(:nth-child(1)) {
          margin-left: 16px;
        }
        span {
          background: #dcdcdc;
          height: 5px;
        }
        &.t-is-active span {
          background: #3278bc;
        }
      }
    }
  }
  &.one {
    :deep(.t-swiper__wrap) {
      .t-swiper__navigation-bars {
        display: none;
      }
    }
  }
}
.t-button {
  border-radius: 0px !important;
}

.banner {
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 900px;
  position: fixed;
  top: 0;
  :deep(.swiper-pagination) {
    bottom: 37px !important;
    .swiper-pagination-bullet {
      width: 100px;
      height: 5px;
      border-radius: 0;
      background: #dcdcdc;
      opacity: 1;
      margin: 0 8px;
      &.swiper-pagination-bullet-active {
        background: #3278bc;
      }
    }
  }

  .t-button--variant-base.t-button--theme-primary {
    background: transparent !important;
  }

  .t_button_img {
    width: 40px;
    height: 40px;
    // margin-left: 24px;
    display: flex;
    position: relative;
    overflow: hidden;

    img {
      width: 40px;
      height: 40px;
    }

    .t_button_img_an {
      position: absolute;
      left: 0;
      top: 0;
      width: 0%;
      overflow: hidden;
      animation: arrow 5s linear infinite;
    }

    @keyframes arrow {
      0% {
        width: 0%;
      }

      10%,
      15% {
        width: 100%;
        transition: all 1s;
      }

      16%,
      60% {
        left: 0;
        width: 100%;
      }

      61%,
      100% {
        left: 40px;
        width: 0%;
        transition: all 3s;
      }
    }
  }

  .t_buttons {
    position: absolute;
    left: 50%;
    bottom: 90px;
    border: 2px solid #ffffff;
    transform: translate(-50%, -50%);
    width: 404px;
    height: 88px;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 80px 0 100px;

    .t_b_content {
      color: rgba(255, 255, 255, 1);
      font-size: 40px;
      font-weight: 500;
      font-family: $bsa-font-pingfang-sc;
      text-align: left;
      white-space: nowrap;
      line-height: 72px;
    }
  }
  .t_buttons_en {
    padding: 0 28px 0 100px;
  }

  video {
    width: 100%;
    height: 100%;
  }

  .w {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
  }
}

// swiper list
.demo_item {
  position: relative;
  width: 100%;
  height: 900px;
  z-index: 0;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
  .video_mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    // background: rgba(0, 0, 0, 0.4);
  }
  .video-title {
    color: #ffffffe6;
    font-size: 80px;
    font-weight: 500;
    font-family: 'PingFang SC';
    text-align: left;
    line-height: 80px;
    position: absolute;
    right: 0;
    bottom: 375px;
    text-align: center;
    left: 0;
    transform: translate(0, -50%);
  }
  .declare-button {
    padding: 8px 79px 7px 100px;
    border: 2px solid #fff;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 372px;
    cursor: pointer;
    position: absolute;
    left: 50%;
    top: 652px;
    text-align: center;
    transform: translate(-50%, 0);
    z-index: 99;
    .title {
      color: #ffffff;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 56px;
    }

    .t_button_img {
      position: relative;
      display: flex;
      width: 34px;
      height: 16px;
      overflow: hidden;

      img {
        width: 34px;
        height: 16px;
      }
    }
  }
  .en-button {
    padding: 8px 39px 7px 100px;
  }
  .end-time {
    position: absolute;
    bottom: 108px;
    left: 0;
    width: 100%;
    font-family: 'PingFang SC';
    font-size: 28px;
    font-weight: 400;
    line-height: 50px;
    color: #ffff;
    text-align: center;
  }
  .decalre-begin {
    position: absolute;
    bottom: 174px;
    left: 50%;
    z-index: 1;
    transform: translate(-50%, 0);
    color: #ffffff;
    font-family: 'PingFang SC';
    font-size: 40px;
    font-weight: 500;
    line-height: 48px;
    white-space: nowrap;
  }
  .tips-content {
    position: absolute;
    top: 444px;
    left: 0;
    width: 100%;
    font-family: 'PingFang SC';
    font-size: 28px;
    font-weight: 400;
    line-height: 50px;
    color: #ffff;
    text-align: center;
    display: flex;
    justify-content: center;
    z-index: 19;
    .line {
      width: 72px;
      height: 2px;
      background-color: #fff;
      margin-top: 30px;
    }
    .tips-text {
      margin: 0 24px;
      color: #fff;
      font-size: 40px;
      line-height: 60px;
      font-weight: 500;
      // max-width: 1116px;
      cursor: pointer;
    }
    .tips-text:hover {
      text-decoration: underline;
      text-underline-offset: 14px;
    }
  }
  .content_tw {
    position: absolute;
    bottom: 416px;
    left: 50%;
    z-index: 11;
    width: 100%;
    font-size: 80px;
    font-weight: 500;
    color: #fff;
    text-align: left;
    transform: translate(-50%, -50%);
    line-height: 120px;

    .view_content {
      width: 100%;
      height: 120px;
      overflow: hidden;
      font-family: $bsa-font-pingfang-sc;

      p {
        position: absolute;
        width: 100%;
        text-align: center;
        opacity: 0;

        span {
          white-space: nowrap;

          i {
            font-style: normal;
          }
        }
      }
    }
  }

  .view_content p:nth-child(1) {
    animation: anim1 15s linear infinite;
  }

  .view_content p:nth-child(2) {
    animation: anim2 15s linear infinite;
  }

  .view_content p:nth-child(3) {
    animation: anim3 15s linear infinite;
  }

  @keyframes anim1 {
    0%,
    1% {
      opacity: 0;
    }

    2%,
    10% {
      opacity: 1;
      transition: opacity 3s;
    }

    11%,
    25% {
      opacity: 1;
    }

    26%,
    30% {
      opacity: 0;
      transition: opacity 3s;
    }

    31%,
    100% {
      opacity: 0;
    }
  }

  @keyframes anim2 {
    0%,
    30% {
      opacity: 0;
    }

    31%,
    40% {
      opacity: 1;
      transition: opacity 3s;
    }

    41%,
    55% {
      opacity: 1;
    }

    56%,
    60% {
      opacity: 0;
      transition: opacity 3s;
    }

    61%,
    100% {
      opacity: 0;
    }
  }

  @keyframes anim3 {
    0%,
    60% {
      opacity: 0;
    }

    61%,
    70% {
      opacity: 1;
      transition: opacity 3s;
    }

    71%,
    85% {
      opacity: 1;
    }

    86%,
    95% {
      opacity: 0;
      transition: opacity 3s;
    }
  }
}

// @media (max-width: 500px) {
//   .banner {
//     height: 450px;
//     position: static;
//   }
//   .banner-swiper {
//     min-height: 450px;
//   }
//   .declare-banner {
//     height: 500px;
//     .banner-swiper {
//       min-height: 500px;
//     }
//   }
// }
// @media (max-width: 999px) and (min-width: 501px) {
//   .banner {
//     height: 580px;
//     position: static;
//   }
//   .banner-swiper {
//     min-height: 580px;
//   }
// }

// 移动端
@media (max-width: 999.9px) {
  .banner {
    height: 450px;
    position: static;
  }
  .banner-swiper {
    height: 450px;
    min-height: 450px;
    max-height: 450px;
  }
  .demo_item {
    // height: 100%;
    .video-title {
      font-size: 40px;
      bottom: 170px;
      line-height: 55px;
    }
    .video_mask {
      z-index: 1;
    }
    .declare-button {
      display: none;
      // padding: 3px 30px 4px 52px;
      // border: 1px solid #fff;
      // width: 185px;
      // align-items: normal;
      // top: auto;
      // bottom: 90px;
      // .title {
      //   font-size: 14px;
      //   line-height: 28px;
      // }

      // .t_button_img {
      //   margin-top: 3px;
      //   // width: 17px;
      //   // height: 8px;
      //   overflow: hidden;
      //   margin-left: 2px;

      //   img {
      //     width: 17px;
      //     height: 8px;
      //   }

      //   .t_button_img_an {
      //     animation: arrow-mobile 5s linear infinite;
      //   }

      //   @keyframes arrow-mobile {
      //     0% {
      //       width: 0%;
      //     }

      //     10%,
      //     15% {
      //       width: 100%;
      //       transition: all 1s;
      //     }

      //     16%,
      //     60% {
      //       left: 0;
      //       width: 100%;
      //     }

      //     61%,
      //     100% {
      //       left: 17px;
      //       width: 0%;
      //       transition: all 3s;
      //     }
      //   }
      // }
    }
    .content_tw {
      top: 200px;
      margin: 0 43px 0 32px;
      font-size: 44px;
      line-height: 75px;
      .view_content p {
        text-align: left;
        i {
          display: block;
        }
      }
    }
    .tips-content {
      top: 224px;
      left: 35px;
      text-align: left;
      justify-content: flex-start;
      font-size: 20px;
      line-height: 30px;
      .line {
        display: none;
      }
      .tips-text {
        margin: 0;
        color: #fff;
        font-size: 20px;
        line-height: 30px;
        max-width: 298px;
      }
      .tips-text:hover {
        text-decoration: none;
        text-underline-offset: 0;
      }
    }
    .end-time {
      bottom: 470px;
      font-size: 12px;
      line-height: 22px;
      padding: 0 32px;
      box-sizing: border-box;
      text-align: left;
    }
    .decalre-begin {
      transform: translate(0, 0);
      bottom: 50px;
      left: 32px;
      font-size: 20px;
      line-height: 29px;
    }
  }
}

// @media (min-width: 1201px) and (max-width: 1440px) {
//   .demo_item {
//     .end-time {
//       bottom: 143px;
//     }
//     .declare-button {
//       top: 615px;
//     }
//     .decalre-begin {
//       bottom: 199px;
//     }
//   }
// }
// @media (min-width: 1001px) and (max-width: 1200px) {
//   .demo_item {
//     .end-time {
//       bottom: 163px;
//     }
//     .declare-button {
//       top: 595px;
//     }
//     .decalre-begin {
//       bottom: 219px;
//     }
//   }
// }
</style>
